import type { PurchaserBookingFragment } from "~/__generated__/graphql/graphql";

export function purchaserBookingState(
  registration: Pick<PurchaserBookingFragment, "status" | "reservations" | "payment">,
) {
  const { status, reservations, payment } = registration;
  if (
    payment?.state === "CANCELLED" ||
    payment?.state === "FAILED" ||
    status.cancelledAt ||
    status.requestState === "DECLINED" ||
    status.requestState === "EXPIRED" ||
    !reservations?.some((value) => value.state !== "CANCELLED")
  )
    return "cancelled";
  if (
    payment?.state === "PROCESSED" &&
    reservations
      .filter((value) => value.state !== "CANCELLED")
      .every((value) => value.state === "CONFIRMED")
  )
    return "confirmed";
  if (
    status.approvalRequired === true &&
    status.submittedAt &&
    !status.approvedAt &&
    status.requestState === "PENDING" &&
    reservations
      .filter((value) => value.state !== "CANCELLED")
      .every((value) => value.state === "PENDING" || value.state === "RESERVED")
  )
    return "pending";
  return "processing";
}

export function isActivePurchaserGroupBooking(
  registration: PurchaserBookingFragment | null | undefined,
  viewerID: string | undefined,
): boolean {
  return !!registration &&
    (registration.originalQuantity ?? 1) > 1 &&
    !!viewerID &&
    registration.purchaser?.id === viewerID &&
    !!registration.status.submittedAt &&
    purchaserBookingState(registration) !== "cancelled";
}
